import React, { useEffect, useRef, useState } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Chart } from 'primereact/chart';
import { InBoundChartServices } from '../../../services/inbound-chart';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Api } from '../../../services/api';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import LeadModel from '../Leads/LeadModel';
import './Inbound.css'; // Import the CSS file
import { format } from "date-fns";
import { Button } from 'bootstrap';
import { set } from 'react-hook-form';
import EditLeads from '../Leads/EditLeads';
import { useNavigate } from 'react-router-dom';

const Inbound = () => {

  const navigate = useNavigate();

  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [overAllData, setOverAllData] = useState([]);
  const [overTableHeader, setOverTableHeader] = useState([]);

  const [OverAllAvgDays, setOverAllAvgDays] = useState([]);
  const [OverAllAvgDaysHeader, setOverAllAvgDaysHeader] = useState([]);

  const [OverAllAvgCounts, setOverAllAvgCounts] = useState([]);
  const [OverAllAvgCountsHeader, setOverAllAvgCountsHeader] = useState([]);

  const [multiFamily, setMultiFamily] = useState([]);
  const [Commercial, setCommercial] = useState([]);
  const [InteriorDesign, setInteriorDesign] = useState([]);
  const [TenantImprovements, setTenantImprovements] = useState([]);
  const [ServiceMaintenance, setServiceMaintenance] = useState([]);
  const [Renovation, setRenovation] = useState([]);
  const [CustomHome, setCustomHome] = useState([]);
  const [getLeadsData, setGetLeadsData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [selectedReport, setSelectedReport] = useState(new Date().getFullYear().toString());
  const [selectedCell, setSelectedCell] = useState(null);
  const [visible, setVisible] = useState(false);
  const [fieldsData, setFieldsData] = useState('Leads');

  const [type, setType] = useState('Add');
  const toast = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [leadsId, setLeadsId] = useState(null);
  const [editLeadList, seteEditLeadList] = useState([]);
  const [isEditModalOpenForClient, setIsEditModalOpenForClient] = useState(false);

  const [sortField, setSortField] = useState('site_visit_date');
  const [sortOrder, setSortOrder] = useState(1);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [dialogHeaderTitle, setDialogHeaderTitle] = useState("LEADS"); // Default title

  useEffect(() => {
    // const currentYear = new Date().getFullYear();
    // setSelectedReport(currentYear);
    chartDataGet(selectedReport);
  }, [selectedReport]);

  

  const chartDataGet = async (year) => {
    setIsLoading(true);

    setOverAllData([]);
    setOverTableHeader([]);
    setOverAllAvgDays([]);
    setOverAllAvgDaysHeader([]);
    setOverAllAvgCounts([]);
    setOverAllAvgCountsHeader([]);
    setMultiFamily([]);
    setCommercial([]);
    setInteriorDesign([]);
    setTenantImprovements([]);
    setServiceMaintenance([]);
    setRenovation([]);
    setCustomHome([]);
    setGetLeadsData([]);
    setChartData({}); // Reset chart data
    setChartOptions({}); // Reset chart options

    
    if (year === 'Over All Average') {  // Over All Average change to over all avarage come data 
      year = 'Over All';
    }

    const token = localStorage.getItem('authToken');

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };

    var baseUrl = Api.API_BASE_URL + "inbound-dashboard";
    fetch(baseUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ year: year }),
    })
      .then((response) => response.json())
      .then((result) => {
        // console.log('result---------------->>>>>', result);

        setIsLoading(false);
        let ovarall2022 = result.OverAll;
        console.log("Overall Data: " + JSON.stringify(ovarall2022));
        let all2022 = InBoundChartServices.FormatData(ovarall2022);
        let totalData = InBoundChartServices.AllTotaldata(ovarall2022);
        all2022.push(totalData);
        let tableheader = InBoundChartServices.getKeyData();
        setOverTableHeader(tableheader);
        setOverAllData(all2022);

        let monthly_leads = ovarall2022.map((x) => x['monthly_leads']);
        let site_visits = ovarall2022.map((x) => x['site_visits']);
        let ce_stage = ovarall2022.map((x) => x['ce_stage']);
        let fsa_stage = ovarall2022.map((x) => x['fsa_stage']);
        let contract_stage = ovarall2022.map((x) => x['contract_stage']);
        let construction_start_stage = ovarall2022.map((x) => x['construction_start_stage']);
        let { chartData, chartLabels, chartOptions } = InBoundChartServices.getChart(monthly_leads, site_visits, ce_stage, fsa_stage, contract_stage, construction_start_stage);
        
        const data = {
          labels: chartLabels,
          datasets: chartData
        };
        setChartData(data);
        // setChartOptions(chartOptions);
        setChartOptions({
          ...chartOptions,
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              color: 'white', // Set the color of the data labels to white
              anchor: 'center', // Positioning of the labels
              align: 'center', // Align the labels
              // formatter: (value) => value.toFixed(1) // Format the displayed value if needed
            },
            legend: {
              display: false // Disable the legend
            }
          },
          scales: {
            y: {

              grid: {
                display: true // Disable horizontal grid lines
              }
            },
            x: {
              title: {
                display: true,
                text: 'Months'
              },
              grid: {
                display: false // You can keep vertical grid lines if needed
              }
            }
          }
        });

        var overAllAvgCounts = InBoundChartServices.OverAllAvgCounts(result.OverAllAvgCounts);
        setOverAllAvgCounts(overAllAvgCounts);

        var avgHeader = InBoundChartServices.OverAllAvgCountHeader();
        setOverAllAvgCountsHeader(avgHeader);

        var overAllAvgDays = InBoundChartServices.OverAllAvgDays(result.OverAllAvgDays);
        setOverAllAvgDays(overAllAvgDays);
        var daysHeader = InBoundChartServices.OverAllDaysCountHeader();
        setOverAllAvgDaysHeader(daysHeader);

        let multi = InBoundChartServices.FormatData(result.multiFamily);
        let multitotalData = InBoundChartServices.AllTotaldata(result.multiFamily);
        multi.push(multitotalData);
        setMultiFamily(multi);

        let commercial = InBoundChartServices.FormatData(result.Commercial);
        let commercialtotalData = InBoundChartServices.AllTotaldata(result.Commercial);
        commercial.push(commercialtotalData);
        setCommercial(commercial);

        let interior = InBoundChartServices.FormatData(result.InteriorDesign);
        let interiortotalData = InBoundChartServices.AllTotaldata(result.InteriorDesign);
        interior.push(interiortotalData);
        setInteriorDesign(interior);

        let tenantImprovements = InBoundChartServices.FormatData(result.TenantImprovements);
        let tenantImprovementstotalData = InBoundChartServices.AllTotaldata(result.TenantImprovements);
        tenantImprovements.push(tenantImprovementstotalData);
        setTenantImprovements(tenantImprovements);

        let serviceMaintenance = InBoundChartServices.FormatData(result.ServiceMaintenance);
        let serviceMaintenancetotalData = InBoundChartServices.AllTotaldata(result.ServiceMaintenance);
        serviceMaintenance.push(serviceMaintenancetotalData);
        setServiceMaintenance(serviceMaintenance);

        let renovation = InBoundChartServices.FormatData(result.Renovation);
        let renovationtotalData = InBoundChartServices.AllTotaldata(result.Renovation);
        renovation.push(renovationtotalData);
        setRenovation(renovation);

        let customHome = InBoundChartServices.FormatData(result.CustomHome);
        let customHometotalData = InBoundChartServices.AllTotaldata(result.CustomHome);
        customHome.push(customHometotalData);
        setCustomHome(customHome);

     
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const getDilogBox = (field, dataKey, year, month) => {
    setGetLeadsData([]);

    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };

    fetch(Api.API_BASE_URL + 'inbound-leads-data', {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ field: field, dataKey: dataKey, year: year, month: month })
    })
      .then((response) => response.json())
      .then((result) => {
        console.log('-------------->', result.result);

        setFieldsData(field)
        console.log(field);
        // setSortField(field);
        setSortField(field === "Leads" ? 'contact_date' :
          field === "Site V" ? 'site_visit_date' :
            field === "CE" ? 'ce_sent_out' :
              field === "Fsa" || field === "NPF" ? 'fsa_date' :
                field === "Cont" ? 'contract_date' :
                  field === "Comp" ? 'completion_date' :
                    'construction_start_date');

        setGetLeadsData(result.result);

        setVisible(true);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const onSelectBodyCell = (event) => {

    console.log("evew", event)
    if (event == null) {
      setSelectedCell(null);
      return false;
    }

    if (selectedReport !== "Over All Average") {
      if (['Leads', 'Site V', 'CE', 'Fsa', 'NPF', 'Cont', 'Cons', 'Comp', 'Warranty'].includes(event.field)) {
        if (event.value != null) {
          getDilogBox(event.field, event.props.dataKey, selectedReport, event.rowData.Month);
        }
      }
    }

   
  };

  const DataTableView = (dataShow, dataKey) => {
    console.log(dataShow)
    const pointerColumns = ['Leads', 'Site V', 'CE', 'Fsa', 'NPF', 'Cont', 'Cons', 'Comp', 'Warranty'];

    return (

      <DataTable
        value={dataShow}
        dataKey={dataKey}
        stripedRows
        cellSelection
        selectionMode="single"
        size="small"
        resizableColumns
        selection={selectedCell}
        onSelectionChange={(e) => onSelectBodyCell(e.value)}
        metaKeySelection={false}
        scrollable // Enable horizontal scrolling
        scrollDirection="both" // Allows both vertical and horizontal scrolling
        frozenWidth="200px" // Adjust width of frozen columns if necessary
        tableStyle={{ minWidth: '50rem', minHeight: '150px', border: '0px', fontSize: '14px' }}
      >

        {/* Other columns that are not frozen */}
        {overTableHeader.map((col, i) => (
          <Column
            id={i}
            key={col.id}
            field={col.id}
            header={col.name}
            frozen={col.name === 'Month' || col.name === 'Leads'}
            style={{ fontSize: '14px', textAlign: 'center', cursor: pointerColumns.includes(col.id) ? 'pointer' : 'default' }}
            headerStyle={{ minWidth: '100px', whiteSpace: 'normal', overflow: 'auto', textTransform: 'capitalize' }}
            body={(rowData) => (
              <span 
                className={typeof rowData[col.id] === 'number' && rowData[col.id] > 0 ? 
                  "cursor-pointer text-blue-600 hover:text-blue-800 hover:underline" : ""}
                // style={{
                //   fontWeight: rowData[col.id] > 0 ? 'bold' : 'normal',
                //   color: rowData[col.id] > 0 ? '#28a745' : '#000',
                // }}
              >
                {rowData[col.id]}
              </span>
            )}
          />
        ))}
      </DataTable>
    );
  }

  // const onCellSelect = (event) => {
  //   if (event.rowData['TRACKING DATA'] == "Total Lost Jobs" || event.rowData['TRACKING DATA'] == "Total Turned Down" || event.rowData['TRACKING DATA'] == "Total FSA Cancelled" || event.rowData['TRACKING DATA'] == "Total Custom Home" || event.rowData['TRACKING DATA'] == "Total Renovations") {
  //     getDilogBoxForCoount(selectedReport, event.rowData['TRACKING DATA']);
  //   }
  // };

  const getDilogBoxForCount = (title, col) => {
    setGetLeadsData([]);
    var _body = { "title": title, "col": col };

    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };

    fetch(Api.API_BASE_URL + 'inbound-leads-data-avg-day', {
      method: "POST",
      headers: headers,
      body: JSON.stringify(_body)
    })
      .then((response) => response.json())
      .then((result) => {
        setGetLeadsData(result.result);
        setVisible(true);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  // const TrackingDataTableView = (dataShow, col) => {
  //   return (
  //     <DataTable value={dataShow} cellSelection selectionMode="single"
  //       tableStyle={{ minHeight: '250px', border: '0px' }} onCellSelect={onCellSelect}>
  //       {col.map((col, i) => (
  //         <Column key={col} field={col} header={col} style={{ fontSize: '14px', textAlign: 'center' }} />
  //       ))}
  //     </DataTable>
  //   );
  // }

  const TrackingDataTableView = ( dataShow ) => {
    const onCellSelect = (item) => {
      if ([
        "Total Lost Jobs",
        "Total Turned Down",
        "Total FSA Cancelled",
        "Total Custom Home",
        "Total Renovations"
      ].includes(item["TRACKING DATA"])) {
        //* ----- Added by Suraj ----------
        setDialogHeaderTitle(item["TRACKING DATA"]);
        //! ----- Added by Suraj ----------
        getDilogBoxForCount(selectedReport, item["TRACKING DATA"]);
      }
    };    

    return (
      <div className="tracking-container">
        {dataShow.map((item, index) => (
          <div key={index} className="tracking-card" onClick={() => onCellSelect(item)}>
            <h3>{item["TRACKING DATA"]}</h3>
            <p>{item.Leads}</p>
          </div>
        ))}
      </div>
    );
  };

  // const TrackingDataTableView = ({ data }) => {
  //   const onCellSelect = (item) => {
  //     if ([
  //       "Total Lost Jobs",
  //       "Total Turned Down",
  //       "Total FSA Cancelled",
  //       "Total Custom Home",
  //       "Total Renovations"
  //     ].includes(item["TRACKING DATA"])) {
  //       getDilogBoxForCoount(selectedReport, item["TRACKING DATA"]);
  //     }
  //   };
  
  //   return (
  //     <div className="tracking-container">
  //       {data.map((item, index) => (
  //         <div
  //           key={index}
  //           className="tracking-card"
  //           onClick={() => onCellSelect(item)}
  //         >
  //           <h4>{item["TRACKING DATA"]}</h4>
  //           <p>{item.Leads}</p>
  //         </div>
  //       ))}
  //     </div>
  //   );
  // };
  

  const reports = [
    { title: 'Over All Average' },
    { title: 'Over All Total' },
    { title: '2027' },
    { title: '2026' },
    { title: '2025' },
    { title: '2024' },
    { title: '2023' },
    { title: '2022' },
    { title: '2021' }
  ];

  const panelClassName = (parent, index) => {
    if (parent.state.activeIndex === index)
      return 'bg-primary-1';
  }

  const AccordionHeader = (title) => {
    return (
      <div className="flex align-items-center m-0">
        <span className="vertical-align-middle">{title}</span>
      </div>
    );
  }

  const getTotalLeads = (data) => {
    // console.log("Received Data:", data);

    return data[data.length - 1].Leads || 0;
        
  };

  const _body = (title) => {
    return (
     <div className='' style={{ overflowX: 'hidden' }}>
            <div className='flex p-2 gap-2'>
              <div className="mt-2" style={{ flex: '0 0 100%', width: '100%' }}>
                {TrackingDataTableView(OverAllAvgCounts, OverAllAvgCountsHeader)}
              </div>
              {/* <div className='col-9 barchart-card '>
                <Chart type="bar" data={chartData} options={chartOptions} height={200} />
              </div> */}
              
              {/* <div className="mt-2 " style={{ flex: '0 0 66%', width: '100%' }}>
                <div className='barchart-card '>
                  <div className='py-2 ' style={{ textAlign: 'center', }}>
                    <span className='title-font'>Bar Chart</span>
                  </div>
                  <div className="chart-container custom-chart py-2" style={{ position: 'relative', height: '214px', paddingLeft: "20px" }}>
                    <Chart type="bar" data={chartData} options={chartOptions} />
                  </div>
                </div>
              </div> */}

            </div>

            <Accordion multiple activeIndex={[0]}>
              <AccordionTab header={AccordionHeader('OVER ALL: ' + getTotalLeads(overAllData))} className='p-1'>
                <div className='row'>
                  <div className='col inboundHorizontal'>
                    {DataTableView(overAllData, "Over All")}
                  </div>
                </div>
              </AccordionTab>
              <AccordionTab header={AccordionHeader('RENOVATIONS: '  + getTotalLeads(Renovation))} className='p-1'>
                <div className='row'>
                  <div className='col inboundHorizontal'>
                    {DataTableView(Renovation, "Renovation")}
                  </div>
                </div>
              </AccordionTab>
              <AccordionTab header={AccordionHeader('CUSTOM HOMES: '  + getTotalLeads(CustomHome))} className='p-1'>
                <div className='row'>
                  <div className='col inboundHorizontal'>
                    {DataTableView(CustomHome, "CustomHome")}
                  </div>
                </div>
              </AccordionTab>
              <AccordionTab header={AccordionHeader('MULTI-FAMILY: '  + getTotalLeads(multiFamily))} className='p-1'>
                <div className='row'>
                  <div className='col inboundHorizontal'>
                    {DataTableView(multiFamily, "multiFamily")}
                  </div>
                </div>
              </AccordionTab>
              <AccordionTab header={AccordionHeader('DEVELOPMENT: '  + getTotalLeads(ServiceMaintenance))} className='p-1'>
                <div className='row'>
                  <div className='col inboundHorizontal'>
                    {DataTableView(ServiceMaintenance, "ServiceMaintenance")}
                  </div>
                </div>
              </AccordionTab>
              <AccordionTab header={AccordionHeader('COMMERCIAL: '  + getTotalLeads(Commercial))} className='p-1'>
                <div className='row'>
                  <div className='col inboundHorizontal'>
                    {DataTableView(Commercial, "Commercial")}
                  </div>
                </div>
              </AccordionTab>
              <AccordionTab header={AccordionHeader('INTERIOR DESIGN: '  + getTotalLeads(InteriorDesign))} className='p-1'>
                <div className='row'>
                  <div className='col inboundHorizontal'>
                    {DataTableView(InteriorDesign, "Interior")}
                  </div>
                </div>
              </AccordionTab>
              <AccordionTab header={AccordionHeader('TENANT IMPROVEMENTS: '  + getTotalLeads(TenantImprovements))} className='p-1'>
                <div className='row'>
                  <div className='col inboundHorizontal'>
                    {DataTableView(TenantImprovements, "TenantImprovements")}
                  </div>
                </div>
              </AccordionTab>
            </Accordion>
          </div>
    );
  }

  const getClientdetail = (rowData) => {
    // console.log(rowData);
    // setLeadsId(rowData.id);
    // seteEditLeadList(rowData);
    // setIsEditModalOpenForClient(true);
    // setType('Edit');

    console.log(rowData);
    // navigate(`/lead-edit/${rowData.id}`); // Navigate to EditLeads page

    const url = `/lead-edit/${rowData.id}`; // Construct the URL to the EditLeads page
    window.open(url, '_blank');

  }

  const closeLeadModel = () => {
    setIsEditModalOpenForClient(false);
  }

  const handleDataRefreshLeadModel = () => {
    setIsEditModalOpenForClient(false);
  }

  const getTotalValue = () => {
    var total = 0;
    
    getLeadsData.forEach(element => {
      if (element.project_value) {
        total += parseFloat(element.project_value);
      }
    });

    return total.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }



  const DateViewTable = (value) => {
    try {
      var date = new Date(value);
      if (isNaN(date.getTime())) {
        return '';
      }
      var formattedDate = format(date, "y-MM-dd");
      return formattedDate;
    } catch (error) {
      return '';
    }
  }

  const onRowSelect = (rowData) => {
    console.log('----------->>',rowData.data._id);

    const url = `/lead-edit/${rowData.data._id}`;
    window.open(url, );
  };

  return (
    <div className="card inbound">
      <div className="dropdown-container">
        <Dropdown
          value={selectedReport}
          options={reports.map(report => ({ label: report.title, value: report.title }))}
          onChange={(e) => setSelectedReport(e.value)}
          placeholder="Select a Report"
          className="dropdown p-2"
        />
      </div>
      {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (
        <p className="m-0">{_body(selectedReport)}</p>
      )}

      <Dialog visible={visible} onHide={() => {
        setSelectedCell(null);
        setVisible(false);
        setIsEditModalOpenForClient(false);
      }}
        style={{ width: '50vw' }}
        // header="LEADS" 
        header={dialogHeaderTitle}
      >
        <>
          <div className='p-3 '>


            <DataTable
              value={getLeadsData}
              tableStyle={{ minWidth: '50rem' }}
              selectionMode="single"
              selection={selectedProduct}
              onRowSelect={onRowSelect}
              onSelectionChange={(e) => setSelectedProduct(e.value)}
              sortField={sortField}
              sortOrder={sortOrder}
              rowClassName={(rowData) => {
                // Determine the relevant date based on `fieldsData`
                const dateField =
                  fieldsData === "Leads" ? rowData.contact_date
                    : fieldsData === "Site V" ? rowData.site_visit_date
                      : fieldsData === "CE" ? rowData.ce_sent_out
                        : fieldsData === "Fsa" || fieldsData === "NPF" ? rowData.fsa_date
                          : fieldsData === "Cont" ? rowData.contract_date
                            : fieldsData === "Comp" ? rowData.completion_date
                              : fieldsData === "Cons" ? rowData.construction_start_date
                                : rowData.warranty_date;

                console.log('rowData.contact_date==========>>', rowData.contact_date);

                // Check if the date is after today
                const isAfterToday = new Date(dateField) > new Date();
                console.log('isAfterTodaye==========>>', isAfterToday);


                // Apply class if date is after the current date
                return isAfterToday ? 'highlight-row' : '';
              }}

              footer={() => (
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 10px 10px 20px', fontSize: '18px', fontWeight: 'bold' }}>
                  <div>
                    <span>Total</span>
                  </div>
                  <div>
                    <span>{getTotalValue()}</span>
                  </div>
                </div>
              )}

            >

              <Column
                header="#"
                body={(rowData, { rowIndex }) => <span>{rowIndex + 1}</span>}
                style={{ width: '50px', textAlign: 'center' }}
              ></Column>
              <Column
                field="client"
                header="Client"
                body={(rowData) => <span>{rowData.client}</span>}
                sortable
                style={{ width: '25%', cursor: 'pointer' }}
              ></Column>

              <Column field="address" header="Address" sortable style={{ width: '25%' }}
                body={(rowData) => (
                  <>
                    {rowData.address === "null null" ? "" : rowData.address} {rowData.internal_job === 'Y' ? '✅' : ''}
                  </>
                )} ></Column>

              <Column field="new_status"
                body={(rowData) => rowData.new_status === "FSA Active" ? "FSA Construction" : rowData.new_status}
                header="Status" sortable style={{ width: '25%', textAlign: 'center' }}></Column>

              <Column
                body={(row) => (
                  <span>
                    {DateViewTable(
                      fieldsData === "Leads" ? row.contact_date.toLocaleString()
                        : fieldsData === "Site V" ? row.site_visit_date
                          : fieldsData === "CE" ? row.ce_sent_out
                            : fieldsData === "Fsa" ? row.fsa_date : fieldsData === "NPF" ? row.fsa_cancelled_date
                              : fieldsData === "Cont" ? row.contract_date
                                : fieldsData === "Comp" ? row.completion_date
                                  : fieldsData === "Cons" ? row.construction_start_date
                                    : row.warranty_date
                    )}
                  </span>
                )}
                field={
                  fieldsData === "Leads" ? 'contact_date'
                    : fieldsData === "Site V" ? 'site_visit_date'
                      : fieldsData === "CE" ? 'ce_sent_out'
                        : fieldsData === "Fsa" ? 'fsa_date' : fieldsData === "NPF" ? 'fsa_cancelled_date'
                          : fieldsData === "Cont" ? 'contract_date'
                            : fieldsData === "Comp" ? 'completion_date'
                              : fieldsData === "Cons" ? 'construction_start_date'
                                : 'warranty_date'
                }
                header={
                  fieldsData === "Leads" ? "Contact Date"
                    : fieldsData === "Site V" ? "First Meeting Date"
                      : fieldsData === "CE" ? "CE Sent Out"
                        : fieldsData === "Fsa" ? "FSA Sign Date" : fieldsData === "NPF" ? "FSA Cancelled Date"
                          : fieldsData === "Cont" ? "Contract Date"
                            : fieldsData === "Comp" ? "Completion Date"
                              : fieldsData === "Cons" ? "Construction Start Date"
                                : "Warranty Date"
                }
                sortable
                style={{ width: '25%', textAlign: 'center' }}
              >
              </Column>

              <Column
                body={(row) => (
                  <span
                    style={{
                      fontWeight: row.project_value > 0 ? 'bold' : 'normal',
                      // color: row.project_value > 0 ? '#28a745' : '#000', // optional, adds green color for values > 0
                    }}
                  >
                    {row.project_value ? parseFloat(row.project_value).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : "$0.00"}
                  </span>
                )}
                header="Value"
                field="project_value"
                sortable
                style={{ width: '25%', textAlign: 'end', padding: '0px 10px' }}
              ></Column>
            </DataTable>


          </div>
        </>
      </Dialog>

      {isEditModalOpenForClient && <LeadModel lead={editLeadList} onClose={closeLeadModel} onDataRefresh={handleDataRefreshLeadModel} />}
    </div>
  );
}

export default Inbound;
